import {cx} from "@emotion/css";

import {ReactComponent as SvgEmail} from "~/assets/svg/email.svg";
import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmEmailcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgEmail id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
